import request from './api'

export async function Get(name,id) {
    try {
        const res = await request('/api/report/get','POST', {name,id})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function GetDocs(kod_sf_list) {
    try {
        const res = await request('/api/report/get-docs','POST', {kod_sf_list})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}
